import React from 'react';
import '../../Styles/PartnerReg.css'; // Import the CSS file

const FAQSection = () => {
  const faqs = [
    {
      question: 'How long will it take to activate my account?',
      answer: 'Once you submit the required documents, it will take 24-48 hours for activation.',
    },
    {
      question: 'Can I update my information later?',
      answer: 'Yes, you can update your information through your dashboard at any time.',
    },
  ];

  return (
    <div className="faq-section">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <button className="faq-question">{faq.question}</button>
            <p className="faq-answer">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
